import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DocumentService } from '../../../documents/documents.service';
import { saveAs } from 'file-saver';
import { SharedModule } from '../../shared.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-material-slideshow',
  templateUrl: './material-slideshow.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MatButtonModule,
  ]
})
export class MaterialSlideshowComponent {
  @Output()
    rmFileId: EventEmitter<string> = new EventEmitter<string>();

  thumbnail: any[] = [];
  fullScreen?: string;
  remove?: string;
  hasrole?: boolean;
  fileName?: string;

  constructor(private _documentsService: DocumentService) {}

  @Input() set fileId(value: []) {
    this.thumbnail = [];
    value.forEach((o) => {
      this._documentsService.download(o).subscribe((b) => {
        const reader = new FileReader();
        reader.readAsDataURL(b.body);
        reader.onload = () => {
          this.thumbnail.push(reader.result);
        };
      });
    });
  }

  @Input() set photoName(value: string) {
    this.fileName = value;
  }

  @Input() set role(value: boolean) {
    this.hasrole = value;
  }

  editMode(rm: string) {
    this.remove = rm.split('/').slice(-1)[0];
    this.rmFileId.emit(this.remove);
  }

  onFullscreen(id: string) {
    this.fullScreen = id;
  }

  downloadDocumentId(blob: string) {
    saveAs(blob, this.fileName);
  }
}
